export enum HelpPageTypes {
  Swagger = 'Swagger',
  OpenAPI = 'OpenAPI'
}

export class HelpPageType {
  helpPageType: HelpPageTypes;
}
